export interface Outcome {
  title: string
  description: string
}

export const outcomes: Outcome[] = [
  {
    title: '⚡ Stop Planning Everything From Scratch',
    description: 'Use professional resources that are already prepared.',
  },
  {
    title: '🐎 Know What to Teach Next',
    description: 'Connect rider needs with exercises, progressions, and next steps.',
  },
  {
    title: '📋 Keep Every Rider Organized',
    description: 'Lessons, observations, development, and progress in one place.',
  },
  {
    title: '🚀 Spend Less Time Preparing',
    description: 'And more time actually teaching.',
  },
]
